module.exports = "/_next/static/images/Pegadaian_logo-23ff3f8c24ca870d6261278999ab4994.png";